import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_VENDOR_EVENT, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_VENDOR_EVENT,
  UPDATE_VENDOR_EVENT,
  DELETE_VENDOR_EVENT
 } from "./actionTypes";
import {
  getVendor_eventSuccess,
  getVendor_eventFail,
  addVendor_eventSuccess,
  addVendor_eventFail,
  updateVendor_eventSuccess,
  updateVendor_eventFail,
  deleteVendor_eventSuccess,
  deleteVendor_eventFail,
  // getVendor_eventProfileSuccess,
  // getVendor_eventProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getVendor_event,
  // getVendor_eventProfile,
  addNewVendor_event,
  updateVendor_event,
  deleteVendor_event,
} from "../../helpers/backend_helper";

function* fetchVendor_event({payload:{id,offset,page_size}}) {
  try {
    const response = yield call(getVendor_event,{id,offset,page_size});
    yield put(getVendor_eventSuccess(response));
  } catch (error) {
    yield put(getVendor_eventFail(error));
  }
}

function* onUpdateVendor_event({ payload: { user, history } }) {
  try {
    let response = yield call(updateVendor_event, user)
    // if (response.file_src || user.removeImage)
    //   user.image = response.file_src
    yield put(updateVendor_eventSuccess(user))
   if(history) history.goBack()
  } catch (error) {
    yield put(updateVendor_eventFail(error))
  }
}

function* onDeleteVendor_event({ payload: ceremony }) {
  
  try {
     yield call(deleteVendor_event, ceremony);
    yield put(deleteVendor_eventSuccess(ceremony));
  } catch (error) {
    yield put(deleteVendor_eventFail(error));
  }
}

function* onAddNewVendor_event({ payload: {user, history } }) {
  try {
    const response =  yield call(addNewVendor_event, user);
    yield put(addVendor_eventSuccess(response.data));
    history.goBack()
  } catch (error) {
    yield put(addVendor_eventFail(error));
  }
}


// function* fetchVendor_catProfile() {
//   try {
//     const response = yield call(getVendor_catProfile);
//     yield put(getVendor_catProfileSuccess(response));
//   } catch (error) {
//     yield put(getVendor_catProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_VENDOR_EVENT, fetchVendor_event);
  yield takeEvery(ADD_NEW_VENDOR_EVENT, onAddNewVendor_event);
  yield takeEvery(UPDATE_VENDOR_EVENT, onUpdateVendor_event);
  yield takeEvery(DELETE_VENDOR_EVENT, onDeleteVendor_event);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchVendor_catProfile);
}

export default ceremonysSaga;
